"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fullWidthHelperStyle = void 0;

var _grid = require("../grid");

var _utils = require("../../utils");

var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var fullWidthStyles = (0, _utils.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100% !important;\n  max-width: 100% !important;\n"])));

var fullWidthHelperStyle = function fullWidthHelperStyle(fullWidth) {
  return (0, _grid.map)(fullWidth, function (fullWidth) {
    return fullWidth ? fullWidthStyles : '';
  });
};

exports.fullWidthHelperStyle = fullWidthHelperStyle;